import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

export default function NavLinkMenu({ to, label, icon }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `flex flex-col items-center justify-center min-w-[40px] min-h-[40px] md:h-[60px] select-none hover:text-cyan-600 dark:hover:text-cyan-500 focus-visible:outline focus-visible:text-cyan-500 dark:focus-visible:text-cyan-600 focus-visible:outline-offset-4 focus-visible:outline-2 focus-visible:outline-cyan-500 dark:focus-visible:outline-cyan-600 focus-visible:rounded-md ${
          isActive
            ? 'text-cyan-500 dark:text-cyan-600 md:underline md:decoration-2 md:underline-offset-2'
            : 'text-zinc-600 dark:text-zinc-300'
        }`
      }>
      <div className="md:hidden">{icon}</div>
      <p className="text-[0.625rem] md:text-sm font-light md:font-medium md:tracking-wider whitespace-nowrap md:uppercase">
        {label}
      </p>
    </NavLink>
  );
}

NavLinkMenu.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
};
